import React, { useCallback, useEffect, useState } from "react";
import { createJob, applyPluginToImage } from "../api";
import { notifications } from "@mantine/notifications";
import { useStore } from "../store";
import { Code, Paper, Text } from "@mantine/core";

/*
One of the bigger problems with this is that jobs is the queue that is being processed.
That is not correct. Every waiting job must be in JOBS as well, otherwise the behavior
looks super hectic to a user.
*/

export default function QueueProcessor() {
  const jobs = useStore((state) => state.jobs);
  const setJobs = useStore((state) => state.setJobs);

  const profile = useStore((state) => state.profile);
  const setProfile = useStore((state) => state.setProfile);

  const [concurrentTasks, setConcurrentTasks] = useState(1); // Default to 1

  useEffect(() => {
    if (profile?.plan === "Pro") {
      setConcurrentTasks(2);
    } else if (profile?.plan === "Premium") {
      setConcurrentTasks(4);
    }
  }, [profile?.plan]);

  const processQueue = useCallback(
    async (nextJob) => {
      // console.debug("processQueue called");
      // const nextJob = jobs.find((p) => p.status === "Waiting");
      // console.debug("nextJob", nextJob);
      const { operation, image, clientId, status } = nextJob;

      try {
        let data;
        if (operation.pluginId) {
          // console.debug("PluginId set, invoking plugin...");
          data = await applyPluginToImage(operation.pluginId, image);
        } else {
          // console.debug("PluginId NOT set, invoking regular job...");
          data = await createJob(operation.id, image);
        }

        // replace the job with the new data from the server:
        var mergedJob = { ...nextJob, ...data };
        // console.debug("Replacing job with new data", mergedJob);
        setJobs(
          jobs.map((p) => (p.clientId === nextJob.clientId ? mergedJob : p))
        );

        setProfile({
          ...profile,
          credits: Math.max(0, profile.credits - operation.credits),
        });
      } catch (error) {
        notifications.show({
          title: "Error",
          message: error.message,
          color: "red",
        });

        var mergedJob = { ...nextJob, status: "Failed", error: error.message };
        // console.debug("Replacing ERRORED job with new data", mergedJob);
        setJobs(
          jobs.map((p) => (p.clientId === nextJob.clientId ? mergedJob : p))
        );
      }
    },
    [jobs]
  );

  useEffect(() => {
    // console.debug("Queue monitoring effect called", jobs);

    // Count the number of active jobs
    var waitingJobs = jobs.filter((p) => p.status === "Waiting");
    var activeJobs = jobs.filter(
      (p) =>
        p.status === "Processing" ||
        p.status === "Queued" ||
        p.status === "Pre-Queued"
    );

    var activeJobCount = activeJobs.length;
    var waitingJobCount = waitingJobs.length;

    if (activeJobCount < concurrentTasks && waitingJobCount > 0) {
      console.debug(
        "Processing next item in queue, activeJobs: ",
        activeJobCount,
        "waitingJobs: ",
        waitingJobCount
      );

      const nextJob = jobs.find((p) => p.status === "Waiting");
      nextJob.status = "Pre-Queued";
      // console.debug("nextJob", nextJob);
      setJobs(jobs.map((p) => (p.clientId === nextJob.clientId ? nextJob : p)));
      // const { operation, image, clientId, status } = nextJob;

      // take the next job
      processQueue(nextJob);
    } else {
      // console.debug("No jobs to process, let's find potential removals...");
      // Remove any jobs that have failed or succeeded
      var removeJobs = jobs.filter(
        (p) => p.status === "Failed" || p.status === "Success"
      );
      if (removeJobs.length > 0) {
        // console.debug("Removing jobs", removeJobs);
        setJobs(
          jobs.filter((p) => p.status !== "Failed" && p.status !== "Success")
        );
      }
    }
  }, [jobs, concurrentTasks, processQueue]);

  return null;

  return (
    <Paper>
      <Text>Queue Processor</Text>
      <Code style={{ whiteSpace: "pre-wrap" }} block>
        Jobs:
        {JSON.stringify(jobs, null, 2)}
      </Code>
    </Paper>
  );
}
